import { TStore } from "redux/reducer";
import { createSelector } from "reselect";

export const selectChannelsState = (state: TStore) => state.channels;

export const selectChannelsPageState = createSelector([selectChannelsState], (state) => state);

export const selectChannelsBtnLoading = createSelector([selectChannelsState], (state) => state.btnLoading);
